import React, { useMemo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Typography } from '@screentone/core';
import classNames from 'classnames';

import { useTrash } from 'contexts/trash/useTrash';
import { DROPPABLE_IDS } from 'utils/collectionDragUtils';
import styles from './PageDraftTrash.module.scss';

const PageDraftTrash = ({
  messageLabel = 'new page',
  overrideStyle = {},
  scratchPadHeight = 0
}: {
  messageLabel?: string;
  overrideStyle?: React.CSSProperties;
  scratchPadHeight?: number;
}) => {
  const { isDragging } = useTrash();

  // Dynamically computes the height to account for scratch pad
  const computedStyle = useMemo(() => {
    const isScratchPadEnabled = localStorage.getItem('scratchpadEnabled') === 'true';
    const scratchPadBaseHeight = isScratchPadEnabled ? scratchPadHeight : 0;
    const scratchPadTopOffset = isScratchPadEnabled && scratchPadBaseHeight ? 10 : 0; // Add some spacing if scratch pad is enabled and visible;

    return {
      height: `calc(100vh - var(--app-page-header-height) - ${scratchPadBaseHeight + scratchPadTopOffset}px)`
    };
    // When isDragging changes we need to recompute the height
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scratchPadHeight, isDragging]);

  return (
    <Droppable key={DROPPABLE_IDS.TRASH} droppableId={DROPPABLE_IDS.TRASH}>
      {(droppableProvided) => (
        <div
          className={classNames(styles.droppable, {
            [styles.droppableInactive]: !isDragging
          })}
          ref={droppableProvided.innerRef}
          {...droppableProvided.droppableProps}
          style={{ ...computedStyle, ...overrideStyle }}
        >
          <Typography className={styles.droppableMessage} color="asphalt" data-testid="page-content-remove-label">
            drag here to remove
            <br />
            from the {messageLabel}
          </Typography>
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default PageDraftTrash;
